<div class="-oneX-container">
    <div class="-oneX-heading--h2">Claim Information</div>
    <br>
    <div class="-oneX-row">
      <div class="-oneX-container -oneX-offset-1">
        <div class="-oneX-container">
          <div class="-oneX-row">
            <div tabindex="-1" class="-oneX-col-md-2 -oneX-col-lg-4" aria-labelledby="Claim Number">
              <div tabindex="0" id="claimNumberField" class="-oneX-body--intro ">{{method}} Number</div>
              <div tabindex="0" id="claimNumber" class="-oneX-body--intro-sm -oneX-typography-variant1">{{info['number']}} </div>
            </div>
            <div tabindex="-1" class="-oneX-col-md-2 -oneX-col-lg-4" aria-labelledby="Date of Loss">
              <div tabindex="0" id="dolField" class="-oneX-body--intro">Date of Loss</div>
              <div tabindex="0" id="dol" class="-oneX-body--intro-sm -oneX-typography-variant1">{{info['dol']}}</div>
            </div>
            <div tabindex="-1" class="-oneX-col-md-2 -oneX-col-lg-4" aria-labelledby="Name">
              <div tabindex="0" id="nameField" class="-oneX-body--intro">Name</div>
              <div tabindex="0" id="name" class="-oneX-body--intro-sm -oneX-typography-variant1">{{info['firstName']}} {{info['lastName']}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>